import apiClient from './apiClient';
import { DayMode, PlanType } from './engineService';

/** A published V2 plan the athlete may enrol in (decision D4). */
export interface AvailablePlan {
  id: string;
  /** The coach's name, else « <race type> <format> » (UPDATE-20). */
  name: string;
  planType: PlanType;
  raceTypeId: number;
  formatId: string | null;
  /** Null for a Débutant plan. */
  format: { code: string; label: string } | null;
  dayMode: DayMode;
  dminWeeks: number;
  dmaxWeeks: number;
  condensedMinWeeks: number | null;
  hasTests: boolean;
  hasPpg: boolean;
  hasBricks: boolean;
}

/** UPDATE-20: Triathlon, Duathlon, Course à pied, Généraliste, Débutant/Reprise. */
export interface RaceType {
  id: number;
  label: string;
  identifier: string;
  planType: PlanType;
  hasFormats: boolean;
}

export interface RaceTypeFormat {
  id: string;
  label: string;
  identifier: string;
}

export const getRaceTypes = async (): Promise<RaceType[]> => (await apiClient.get('race-types')).data;

export const getRaceTypeFormats = async (raceTypeId: number): Promise<RaceTypeFormat[]> =>
  (await apiClient.get(`race-types/${raceTypeId}/formats`)).data;

/** Generatable plans of one (race type, format); `formatId` is omitted for Débutant. */
export const getSelectablePlans = async (raceTypeId: number, formatId?: string): Promise<AvailablePlan[]> =>
  (await apiClient.get('plans/selectable', { params: { raceTypeId, formatId } })).data;
